const SHORT_SHA = String(process.env.REACT_APP_GIT_SHA || "").trim() || "dev";

/** Fixed corner marker so we can tell which build is serving Ops. */
export function BuildCommitRibbon() {
  return (
    <div
      style={{
        position: "fixed",
        right: 8,
        bottom: 8,
        zIndex: 9999,
        pointerEvents: "none",
        userSelect: "none",
        fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
        fontSize: 10,
        lineHeight: 1,
        padding: "3px 6px",
        borderRadius: 4,
        color: "var(--text-muted)",
        background: "var(--surface2, #F5F2EC)",
        border: "1px solid var(--border)",
        boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
        opacity: 0.92,
      }}
      title={`stiq-ops build ${SHORT_SHA}`}
      aria-label={`Build ${SHORT_SHA}`}
    >
      ops · {SHORT_SHA}
    </div>
  );
}
